module.exports = __webpack_public_path__ + "media/src/images/logo-c84800040038acefc63c5f5ecd3c8a71.png";